import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class CheckboxButton extends Vue {
	@Prop()
	public icon = "";

	@Prop()
	public iconOn = "";

	@Prop()
	public color = "";

	@Prop()
	public disabled = false;

	@Prop()
	public iconOff = "";

	public isChecked = false;
	public currentIcon = "";

	public mounted(): void {
		this.currentIcon = this.iconOn;
	}

	public switchState(): void {
		this.isChecked = !this.isChecked;
		this.changeIcon();
		this.$emit("click");
	}

	@Watch("iconOn")
	public changeIcon(): void {
		this.currentIcon = (!this.isChecked) ? this.iconOn : this.iconOff;
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/CheckboxButton/checkbox-button.ts